import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { ActivistInstitutionsModel } from './activist-institutions.model';

export class ActivistInstitutionsConfiguration extends ReportSectionConfigurationBase {
  typeName = 'ActivistInstitutionsConfiguration';
  nodataLocalizationKeyName = 'activistOwnershipInstitutions';
  readonly reportSection = ReportSection.Activist;
  readonly applicableReportTypes = [ReportType.OwnershipAnalyticsReport];
  readonly reportViewModelSections = [ReportViewModelSection.OwnershipAnalyticsReport_ActivistInstitutions];
  readonly minSize = 2;
  readonly maxSize = 4;
  readonly defaultSize = 4;
  readonly availableDataSections = [];

  get name(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'activistOwnershipInstitutions';
    } else {
      throw new Error('Report Type not supported');
    }
  }

  get displayName(): string {
    if (this.appliedReportType === ReportType.OwnershipAnalyticsReport) {
      return 'Activist';
    } else {
      throw new Error('Report Type not supported');
    }
  }
}

export interface ActivistInstitutionsData {
  [ReportViewModelSection.OwnershipAnalyticsReport_ActivistInstitutions]: ActivistInstitutionsModel;
}
